import axios from '../request'

export interface ReportClickParams {
  // 设备类型：MP-小程序，M-移动端，PC-PC端
  device: 'MP' | 'M' | 'PC'
  // 路由路径
  route: string
  systemInfo: string
}

/**
 * 上报点击事件
 */
export function fetchReportClick(data: ReportClickParams) {
  return axios.post('/udc/save', data)
}